import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */

/**
 * Tab Panel that show/hide contents when a tab is changed
 * Vaadin Tabs are just the tab only. Use component to have proper tab panel 
 * 
 * Child element turn into table with the tab-title attribute as the tab (HTML supported).
 * Set tab-title-trusted: false when tab-title is dynamic/untrusted server text.
 * 
 */
class TabPanel extends BaseComponent {
	
	static get properties() {
		return {
			tabs: {type: Array},
			initialTabIndex: {type: Number}
		};
	}
	
	constructor() {
		super();
		
		this.tabs = [];
		this.initialTabIndex = 0;
		this.tabSet = [];
		
		var tabPanel = this;
		setTimeout(function(){
			tabPanel.init();
		});		
	}
	
	render() {
		return html`
			<style>
				.hide {
					display: none
				}				
			</style>
			<slot></slot>		
		`;
	}
	
	init() {
		var tabPanel = this;
		
		tabPanel.tabContainer = ElementUtil.create({
			tag: 'vaadin-tabs',
			slot: 'toolbar',
			listeners: {
				'selected-changed': function(event) {					
					var newTabIndex = event.detail.value;					
					tabPanel.showSelectTab(newTabIndex);
					
					var changeEvent = new CustomEvent('change', { detail: {
						newIndex: newTabIndex,
						tab: tabPanel.tabSet[newTabIndex]
					}});
					tabPanel.dispatchEvent(changeEvent);
				}
			}
		});
		
		
		tabPanel.layoutContainer = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				tabPanel.tabContainer
			]
		});
		
		tabPanel.append(tabPanel.layoutContainer);
		
		if (tabPanel.tabs && tabPanel.tabs.length > 0) {
			tabPanel.addTabs(tabPanel.tabs);
		}
		
		var readyEvent = new CustomEvent('ready', { detail: '' });
		tabPanel.dispatchEvent(readyEvent);
	}
	
	addTabs(tabConfigs) {
		var tabPanel = this;
		
		tabConfigs.forEach(function(tabConfig){
			
			var tab = ElementUtil.create({
				tag: 'vaadin-tab',
				innerHTML: tabConfig['tab-title'],
				trustedInnerHTML: tabConfig['tab-title-trusted'] !== false
			});			
			tabPanel.tabContainer.append(tab);
			
			tabConfig.slot = 'primary';
			var tabContent = ElementUtil.create(tabConfig);
			tabContent.classList.add('hide');
			tabPanel.layoutContainer.append(tabContent);
			
			tabPanel.tabSet.push({				
				tab: tab,
				content: tabContent
			});
			if (tabConfig.postAdd) {
				tabConfig.postAdd();
			}
		});		
				
		if (tabConfigs.length > 0) {
			tabPanel.showSelectTab(tabPanel.initialTabIndex);
		}		
	}
	
	removeAllTabs() {
		var tabPanel = this;
		tabPanel.tabSet.forEach(function(fulltab){
			fulltab.remove();	
		});
		tabPanel.tabSet = [];
	}
	
	showSelectTab(index) {
		var tabPanel = this;
		
		tabPanel.tabSet.forEach(function(fulltab){
			if (fulltab.content) {
				fulltab.content.classList.add('hide');
			}
		});
		var selected = tabPanel.tabSet[index];
		if (selected && selected.content) {
			selected.content.classList.remove('hide');
		}
	}
	
	selectedTab() {
		var tabPanel = this;		
		return tabPanel.tabContainer.selected;
	}	
	
};
customElements.define('dl-tabpanel', TabPanel);
